export default [
  {
    type: 'input',
    placeholder: '操作人',
    filed: 'admin',
    default: ''
  },
  {
    type: 'select',
    placeholder: '操作类型',
    filed: 'operationType',
    default: '',
    options: [
      {
        code: 1,
        name: '登录'
      },
      {
        code: 2,
        name: '新增'
      },
      {
        code: 3,
        name: '修改'
      },
      {
        code: 4,
        name: '删除'
      },
      {
        code: 5,
        name: '导入'
      },
      {
        code: 6,
        name: '其他'
      }
    ]
  },
  {
    type: 'input',
    placeholder: '用户IP',
    filed: 'ip',
    default: ''
  },
  {
    type: 'datepicker',
    filed: 'daterange',
    params: {
      start: 'startTime',
      end: 'endTime'
    },
    default: ''
  }
]
